import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="catalog--bulk-add"
// Manages checkbox selection and search filtering for bulk adding attribute definitions
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "count", "search", "group"]

  toggle() {
    this.updateState()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    // Only toggle visible (non-hidden) checkboxes
    this.checkboxTargets.forEach((cb) => {
      if (!cb.closest("[data-bulk-add-item]").hidden) {
        cb.checked = checked
      }
    })
    this.updateState()
  }

  connect() {
    this.updateState()
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim()

    this.groupTargets.forEach((group) => {
      let visibleCount = 0
      const items = group.querySelectorAll("[data-bulk-add-item]")

      items.forEach((item) => {
        const name = (item.dataset.name || "").toLowerCase()
        const key = (item.dataset.key || "").toLowerCase()
        const match = !query || name.includes(query) || key.includes(query)
        item.hidden = !match
        if (match) visibleCount++
      })

      // Hide entire group if no items match
      group.hidden = visibleCount === 0

      if (visibleCount > 0) {
        const accordion = this.application.getControllerForElementAndIdentifier(
          group,
          "ui--accordion",
        )
        // Auto-open groups that have matches when searching; when the search is
        // cleared, re-fit any group left open (its item set changed).
        if (query) accordion?.open()
        else accordion?.refresh()
      }
    })

    this.updateState()
  }

  clearSearch() {
    this.searchTarget.value = ""
    this.filter()
  }

  updateState() {
    const visible = this.checkboxTargets.filter(
      (cb) => !cb.closest("[data-bulk-add-item]").hidden,
    )
    const checked = visible.filter((cb) => cb.checked)

    // Update select all checkbox (scoped to visible items)
    this.selectAllTarget.checked =
      checked.length === visible.length && visible.length > 0
    this.selectAllTarget.indeterminate =
      checked.length > 0 && checked.length < visible.length

    // Update count badge (total checked, including hidden)
    const totalChecked = this.checkboxTargets.filter((cb) => cb.checked)
    this.countTarget.textContent = totalChecked.length.toString()
  }
}
